export default __webpack_public_path__ + "static/media/white-avatar.f2d79ea5.png";